import React from 'react';

import { Link } from 'gatsby';

import Container from '../Container';
import Map from '../Map';

import logo from '../../../static/logo-full-color.svg';
import oopstypo from '../../../static/oopstypo.svg';

import nav, { getNavItem } from '../../lib/nav';

import styles from './index.module.scss';

import fb from '../../../static/fb.svg';
import linkedin from '../../../static/linkedin.svg';
import twitter from '../../../static/twitter.svg';

const footerLinks = ['the-kingston-difference', 'life-at-kingston', 'admissions'];
const miscLinks = [
  {
    ...getNavItem('learning-at-kingston', 'early-years'),
    text: {
      en: 'Learning at Kindergarten',
      zh: '在京斯敦幼稚園學習',
    },
  },
  {
    ...getNavItem('learning-at-kingston', 'primary-school'),
    text: {
      en: 'Learning at Primary School',
      zh: '在京斯敦小學學習',
    },
  },
  {
    ...getNavItem('learning-at-kingston', 'secondary-school'),
    text: {
      en: 'Learning at Secondary School',
      zh: '在中學學習',
    },
  },
  getNavItem('working-at-kingston'),
  getNavItem('contact-us'),
];

const renderFooterLinks = (locale, key, items) => (
  <ul>
    {items.map(item => (
      <li key={item.key}>
        {item.url ? (
          <a href={item.url}>{item.text[locale]}</a>
        ) : (
          <Link exact to={`/${locale}${item.uri}`}>
            {item.text[locale]}
          </Link>
        )}
      </li>
    ))}
  </ul>
);

/* eslint-disable react/prop-types */
export default ({ locale = 'en', showMap = true }) => (
  <div className={styles.root}>
    {showMap && (
      <Container className={styles.contact}>
        {locale === 'en' ? (
          <div className={styles.info}>
            <h4 className={styles.schoolName}>Kingston International School</h4>
            <p>
              113 Waterloo Road <br /> Kowloon Tong, Kowloon, Hong Kong
            </p>
            <p>
              Tel: 852 2337 9031
              <br />
              Email: enquiry@kingston.edu.hk
            </p>
          </div>
        ) : (
          <div className={styles.info}>
            <h4 className={styles.schoolName}>京斯敦國際學校</h4>
            <p>香港九龍九龍塘窩打老道113號</p>
            <p>
              電話 : (852) 2337 9031
              <br />
              電郵: enquiry@kingston.edu.hk
            </p>
          </div>
        )}
        <div className={styles.map}>
          <Map defaultZoom={16} coords={{ lat: 22.32869, lng: 114.178193 }} />
        </div>
      </Container>
    )}
    <footer className={showMap ? styles.hasMap : ''}>
      <Container className={styles.footerWrapper}>
        <div className={styles.kingston}>
          <img className={styles.logo} src={logo} alt="Kingston International School" />
          <div className={styles.social}>
            <a href="https://www.facebook.com/kingstonhkpyp" target="_blank" rel="noopener noreferrer">
              <img src={fb} alt="Facebook" />
            </a>
            <a href="https://twitter.com/kingstonishk" target="_blank" rel="noopener noreferrer">
              <img src={twitter} alt="Twitter" />
            </a>
            <a
              href="https://hk.linkedin.com/company/kingston-international-school"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="LinkedIn" />
            </a>
          </div>
        </div>

        <div className={styles.linksWrapper}>
          <div className={styles.links}>
            <h5 className={styles.title}>{locale === 'en' ? 'Kingston International' : '京斯敦國際學校'}</h5>
            {renderFooterLinks(locale, 'misc', miscLinks)}
          </div>
          {footerLinks.map(key => nav.find(m => m.key === key)).map(({ text, key, items }) => (
            <div key={key} className={styles.links}>
              <h5 className={styles.title}>{text[locale]}</h5>
              {renderFooterLinks(locale, key, items)}
            </div>
          ))}
        </div>

        <a className={styles.oopstypo} href="http://oopstypo.com" target="_blank" rel="noopener noreferrer">
          Designed by
          <img src={oopstypo} alt="Oops Typo Ltd" />
        </a>

        <div className={styles.copyright}>Copyright {new Date().getFullYear()} Kingston International School</div>
      </Container>
    </footer>
  </div>
);
